import {DeviceAlarmStatusEnum} from "../notification/DeviceAlarmStatus";
import {DeviceType} from "../device-type/DeviceType";

export class Device {
  id!: number;
  name!: string;
  online?: boolean;
  alarmStatus?: DeviceAlarmStatusEnum;
  partitionId!: number;
  gatewayId!: number;
  type!: DeviceType;

  transportConfiguration?: any;

  acquisitionCron?: string;

  isVirtualMeasure?: boolean;

  constructor() {

    this.acquisitionCron = "M1";
    this.isVirtualMeasure = false;
    this.transportConfiguration = {};

  }
}
